import { Link } from 'react-router-dom';

import { DataTable, type Column } from '../components/DataTable.tsx';
import { Pagination } from '../components/Pagination.tsx';
import { dateOnly, money, statusClass, statusLabel } from '../lib/format.ts';
import { usePaginatedList } from '../lib/usePaginatedList.ts';

interface Row {
  id: number;
  poNo: string;
  poDate: string;
  creditorNo: string | null;
  creditorName: string | null;
  currency: string;
  value: number;
  status: string;
}

export function PurchaseOrdersListPage() {
  const list = usePaginatedList<Row>({
    endpoint: '/api/dashboard/purchase-orders',
    defaultSortColumn: 'po_date',
    defaultSortDirection: 'DESC',
  });
  const columns: Column<Row>[] = [
    { key: 'po_no', label: 'PO no', sortable: true, className: 'mono', render: (r) => <Link to={`/purchase-orders/${encodeURIComponent(r.poNo)}`}>{r.poNo}</Link> },
    { key: 'po_date', label: 'Date', sortable: true, className: 'mono', render: (r) => dateOnly(r.poDate) },
    { key: 'creditor_no', label: 'Supplier', sortable: true, render: (r) => r.creditorNo ? <Link to={`/suppliers/${encodeURIComponent(r.creditorNo)}`}>{r.creditorName ?? r.creditorNo}</Link> : '—' },
    { key: 'value', label: 'Value', sortable: true, className: 'num', render: (r) => money(r.value, r.currency) },
    { key: 'status', label: 'Status', sortable: true, render: (r) => <span className={`badge ${statusClass(r.status)}`}>{statusLabel(r.status)}</span> },
  ];
  return (
    <>
      <header className="main-header">
        <h1 className="main-title">Purchase orders</h1>
        <span className="main-subtitle">{list.data ? `${list.data.total} total` : ''}</span>
      </header>
      <div className="toolbar">
        <input placeholder="Search PO no or ref…" defaultValue={list.state.search} onChange={(e) => list.setSearch(e.target.value)} />
      </div>
      {list.error && <div className="error">{(list.error as Error).message}</div>}
      {list.isLoading && !list.data && <div className="loading">Loading…</div>}
      {list.data && (
        <>
          <DataTable columns={columns} rows={list.data.rows} rowKey={(r) => r.id} sortColumn={list.state.sortColumn} sortDirection={list.state.sortDirection} onSortChange={list.toggleSort} />
          <Pagination page={list.state.page} pageSize={list.state.pageSize} total={list.data.total} onPageChange={list.setPage} />
        </>
      )}
    </>
  );
}
